import ReactVisibilitySensor from 'react-visibility-sensor';

interface Props {
  onReachedBottom(): void;
}

export default function TnCContent({ onReachedBottom }: Props) {
  return (
    <>
      <h1 className="title">
        Syarat Dan Ketentuan Transaksi Efek Bersifat Utang dan Sukuk (EBUS) di
        Pasar Sekunder
      </h1>
      <ol>
        <li>
          Investasi pada EBUS mengandung risiko investasi, termasuk namun tidak
          terbatas pada adanya risiko pasar, risiko likuiditas, dan risiko gagal
          bayar yang dapat berakibat pada berkurang atau hilangnya pokok
          investasi.
        </li>
        <li>
          Kinerja EBUS di masa lalu bukan merupakan jaminan atas kinerja dan
          hasil investasi di masa mendatang.
        </li>
        <li>
          Harga yang tertera pada Aplikasi PT Stockbit Sekuritas Digital
          (Stockbit) merupakan harga indikasi dan dapat berubah sewaktu-waktu.
        </li>
        <li>
          Instruksi pembelian/penjualan EBUS yang disampaikan oleh Nasabah
          melalui Stockbit tidak dapat dibatalkan. Transaksi yang terlaksana
          atas instruksi pembelian/penjualan EBUS yang diajukan oleh nasabah dan
          disetujui oleh Stockbit adalah transaksi yang sah, mengikat dan tidak
          dapat diubah dan/atau dibatalkan oleh Nasabah. Konfirmasi atas
          transaksi tersebut akan dikirimkan secara elektronik, bersifat akurat
          dan benar serta mengikat bagi Nasabah.
        </li>
        <li>
          Nasabah wajib memastikan kecukupan dana di Rekening Dana Nasabah (RDN)
          pada saat menyampaikan instruksi pembelian EBUS, instruksi dari
          Nasabah akan ditolak oleh Stockbit apabila dana di RDN Nasabah tidak
          mencukupi pada saat penyampaian instruksi dan/atau pada saat
          verifikasi instruksi.
        </li>
        <li>
          Apabila transaksi pembelian atas instruksi tersebut terlaksana, maka
          Stockbit berhak untuk melakukan pendebetan dana di RDN Nasabah pada
          tanggal settlement sejumlah nominal yang harus dibayarkan oleh
          Nasabah.
        </li>
        <li>
          Apabila transaksi penjualan atas instruksi tersebut terlaksana, maka
          Dana hasil penjualan akan dicairkan langsung ke RDN pada tanggal
          settlement (T+2)
        </li>
        <li>Distribusi Kupon EBUS akan dicairkan langsung ke RDN.</li>
        <li>
          Transaksi EBUS pada Pasar Sekunder dikenakan pemotongan Pajak
          Penghasilan (PPh) final sebesar 10% atas penghasilan berupa kupon
          berjalan dan keuntungan (capital gain) yang diterima, serta biaya Bea
          Meterai yang akan dikenakan sesuai dengan ketentuan hukum dan
          peraturan perundang-undangan yang berlaku.
        </li>

        <li>
          Nasabah wajib membaca dan mempelajari seluruh informasi, manfaat, dan
          risiko terkait dengan EBUS, termasuk dan tidak terbatas pada informasi
          yang dimuat dalam Syarat dan Ketentuan, Produk Info, Memorandum
          Informasi, dan/atau dokumen lainnya yang berkaitan dengan keterbukaan
          informasi.
        </li>

        <li>
          Nasabah membebaskan Stockbit dari segala bentuk tuntutan, ganti rugi,
          gugatan, dan/atau tindakan hukum lainnya dari pihak manapun yang
          timbul sehubungan dengan Transaksi EBUS di Pasar Sekunder yang telah
          diajukan dan disetujui.
        </li>
      </ol>
      <ReactVisibilitySensor
        onChange={(value) => {
          if (value) {
            onReachedBottom();
          }
        }}
        scrollCheck
        key="visibility-sensor"
      >
        <div className="sensor">&nbsp;</div>
      </ReactVisibilitySensor>
    </>
  );
}
